import {AbstractControl, ValidatorFn} from '@angular/forms';


export function paymentCodeValidator(): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value == '***') {
            return { 'paymentCodeInvalid': true };
        }
        return null;
    }

}
